'use strict';

angular.module('TurneroApp').component('coEncuesta', {
    bindings: {
    },
    controller: [
        'utilsService',
        'TurneroAppConstant',
        'encuestaService',
        '$stateParams',
        '$window',
        '$scope',
        function (utilsService, TurneroAppConstant, encuestaService, $stateParams, $window, $scope) {
            var ctrl = this;
            ctrl.tiposRespuesta = TurneroAppConstant.TiposRespuesta;
            //ctrl.respuestas = [];
            ctrl.preguntas = [];

            ctrl.$onChanges = function () {
                ctrl.Id_Turno = $stateParams.idTurno ? $stateParams.idTurno : null
                ctrl.Id_Calificacion = $stateParams.idCalificacion ? $stateParams.idCalificacion : null;
                var Hash = $stateParams.hash ? $stateParams.hash : null
                var hash_Id_Turno = SHA256(ctrl.Id_Turno.toString());
                if (hash_Id_Turno == Hash) {
                    if (ctrl.Id_Turno > 0 && ctrl.Id_Calificacion) {
                        ctrl.Encuesta_Respondida = false;
                        ctrl.Encuesta_Enviada = false
                        ctrl.GetFormulario()
                    }
                }

            }

            ctrl.GetFormulario = function () {
                encuestaService.Get_Preguntas_Turno({
                    'id_turno': ctrl.Id_Turno,
                    'id_opcion_calificacion': null
                }).$promise.then(function (resultado) {
                    ctrl.preguntas = resultado.Data.Preguntas;
                    ctrl.tramiteRelevado = resultado.Data.N_Tramite_Relevado;
                    ctrl.centroAtencion = resultado.Data.N_Centro_Atencion;

                    if (resultado.Data.Cantidad_Respondidas == 0) {
                        ctrl.Encuesta_Respondida = false;

                        if (resultado.Data.Respuestas_Emoji == 0) {
                            var arrayRespuesta = [{
                                Id_Opcion_Calificacion: 0,
                                Puntaje: ctrl.Id_Calificacion
                            }]

                            encuestaService.Guardar_Respuestas({
                                'Id_Turno': ctrl.Id_Turno
                            }, arrayRespuesta
                            ).$promise.then(function (result) {

                            }).catch(function (error) {
                                utilsService.errores(error);
                            });
                        };
                    } else {
                        ctrl.Encuesta_Enviada = true;
                    }
                }).catch(function (error) {
                    utilsService.errores(error);
                });
            }

            ctrl.Confirmacion = function () {
                let completo = true;
                let arrayRespuesta = [];

                ctrl.deshabilitarBoton = true;

                for (var i = 0; i < ctrl.preguntas.length; i++) {
                    var pregunta = ctrl.preguntas[i];
                    //var respuesta = ctrl.respuestas[i];

                    if ((pregunta.Id_Tipo_Respuesta == ctrl.tiposRespuesta.UnoAlDiez && !pregunta.Puntaje) ||
                        (pregunta.Id_Tipo_Respuesta == ctrl.tiposRespuesta.SiNo && !pregunta.Id_Opcion_Respuesta) ||
                        (pregunta.Id_Tipo_Respuesta == ctrl.tiposRespuesta.Opciones && !pregunta.Id_Opcion_Respuesta)) {

                        swal({
                            title: 'Preguntas sin responder',
                            text: 'Se deben responder todas las preguntas antes de poder enviar la calificación.',
                            type: 'warning',
                            confirmButtonText: 'Aceptar',
                            allowEscapeKey: false,
                            allowOutsideClick: false
                        });

                        completo = false;
                        ctrl.deshabilitarBoton = false;
                        break
                    }
                    else if (pregunta.Id_Tipo_Respuesta != ctrl.tiposRespuesta.Texto || pregunta.Observaciones) {
                        arrayRespuesta.push({
                            Id_Opcion_Calificacion: pregunta.Id_Opcion_Calificacion,
                            Puntaje: pregunta.Puntaje,
                            Id_Opcion_Respuesta: pregunta.Id_Opcion_Respuesta,
                            Comentario: pregunta.Comentario,
                            Observaciones: pregunta.Observaciones
                        });
                    }
                }

                if (completo) {
                    //ctrl.Id_Turno
                    encuestaService.Guardar_Respuestas({
                        'Id_Turno': ctrl.Id_Turno
                    }, arrayRespuesta).$promise.then(function (resultado) {
                        swal({
                            title: 'Encuesta recibida',
                            html: 'La encuesta fue enviada correctamente.<br/> Muchas Gracias!',
                            type: 'success',
                            confirmButtonText: 'Aceptar',
                            allowEscapeKey: false,
                            allowOutsideClick: false
                        }).then(function () {
                            ctrl.Encuesta_Respondida = true;
                            $scope.$apply();
                            ctrl.cancelar();
                        }, function (error) {
                            swal.close();
                            utilsService.errores(error);
                        })
                        ctrl.deshabilitarBoton = false;
                    }).catch(function (error) {
                        ctrl.deshabilitarBoton = false;
                        utilsService.errores(error);
                    });
                }
            }

            ctrl.cancelar = function () {
                //window.close();
            }

        }],
    template: require('./encuesta.html')
});



// WEBPACK FOOTER //
// ./app/components/layout/encuestas/encuestaComponent.js